var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "page-header",
        {
          attrs: {
            title: _vm.$t("pages.admin.series.title"),
            "icon-class": "mdi mdi-television"
          }
        },
        [
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _c(
                "router-link",
                {
                  staticClass: "text-primary font-weight-bold",
                  attrs: { tag: "a", to: { name: "admin.series.create" } }
                },
                [
                  _c("i", { staticClass: "mdi mdi-plus" }),
                  _vm._v(
                    " " + _vm._s(_vm.$t("actions.create")) + "\n            "
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card shadow-sm" }, [
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c("div", { staticClass: "table-responsive" }, [
              _c(
                "table",
                { staticClass: "table table-striped table-borderless" },
                [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [
                        _vm._v(_vm._s(_vm.$t("pages.admin.series.model.title")))
                      ]),
                      _vm._v(" "),
                      _c("th", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("pages.admin.series.model.show_in_sidebar")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("th", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("pages.admin.series.model.show_in_coach")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("th", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("pages.admin.series.model.amount_of_video")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("th", [_vm._v(_vm._s(_vm.$t("actions.actions")))])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.seriesList, function(series) {
                      return _c("tr", [
                        _c("td", [
                          _c("img", {
                            staticClass: "img-thumbnail mr-2",
                            attrs: {
                              src: series.thumbnail_url,
                              alt: series.title[_vm.$i18n.locale]
                            }
                          }),
                          _vm._v(
                            "\n                                " +
                              _vm._s(series.title[_vm.$i18n.locale]) +
                              "\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          series.show_in_sidebar
                            ? _c(
                                "span",
                                { staticClass: "badge badge-success" },
                                [_c("i", { staticClass: "mdi mdi-check" })]
                              )
                            : _c(
                                "span",
                                { staticClass: "badge badge-danger" },
                                [_c("i", { staticClass: "mdi mdi-close" })]
                              )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          series.show_in_coach
                            ? _c(
                                "span",
                                { staticClass: "badge badge-success" },
                                [_c("i", { staticClass: "mdi mdi-check" })]
                              )
                            : _c(
                                "span",
                                { staticClass: "badge badge-danger" },
                                [_c("i", { staticClass: "mdi mdi-close" })]
                              )
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(series.video_count))]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "btn btn-outline-primary btn-sm",
                                attrs: {
                                  tag: "button",
                                  to: {
                                    name: "series.show",
                                    params: { slug: series.slug }
                                  }
                                }
                              },
                              [_c("i", { staticClass: "mdi mdi-eye" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "router-link",
                              {
                                staticClass: "btn btn-outline-warning btn-sm",
                                attrs: {
                                  tag: "button",
                                  to: {
                                    name: "admin.series.edit",
                                    params: { slug: series.slug }
                                  }
                                }
                              },
                              [_c("i", { staticClass: "mdi mdi-pencil" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "router-link",
                              {
                                staticClass: "btn btn-outline-dark btn-sm",
                                attrs: {
                                  tag: "button",
                                  to: {
                                    name: "admin.series.videos",
                                    params: { slug: series.slug }
                                  }
                                }
                              },
                              [_c("i", { staticClass: "mdi mdi-television" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-outline-danger btn-sm float-right",
                                on: {
                                  click: function($event) {
                                    _vm.selectedSeries = series
                                  }
                                }
                              },
                              [_c("i", { staticClass: "mdi mdi-trash-can" })]
                            )
                          ],
                          1
                        )
                      ])
                    }),
                    0
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("series-delete-modal", {
              attrs: { selected: _vm.selectedSeries },
              on: {
                "series-deleted": _vm.onSeriesDeleted,
                "modal-close": function($event) {
                  _vm.selectedSeries = null
                }
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }